import { Spin } from 'antd'
import React from 'react'

function MessageLoading() {
    return (
        <div style={{width:"100%",padding: "15px 0", margin:"20px auto", display:"grid",placeItems:"center"}} >
            <Spin/>
        </div>
    )
}

export default MessageLoading
